import CameraIcon from '@mui/icons-material/Camera';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import CakeIcon from '@mui/icons-material/Cake';
import PregnantWoman from '@mui/icons-material/PregnantWoman';
import Person from '@mui/icons-material/Person';
import NaturePeople from '@mui/icons-material/NaturePeople';

import weddingImage from './styles/images/services/weddings.jpg';
import batMitzvaImage from './styles/images/services/bat-mitzva.jpg';
import eventImage from './styles/images/services/events.jpg';
import fashionImage from './styles/images/services/fashion.jpg';
import maternityImage from './styles/images/services/maternity.jpg';
import coupleImage from './styles/images/services/couples.jpg';

import annaAvatar from './styles/images/testimonials/anna.webp';
import timnaAvatar from './styles/images/testimonials/timna.webp';
import galAvatar from './styles/images/testimonials/gal.webp';


const translations = {
  he: {
    nav: [
    { id: 'home', label: 'בית' },
    { id: 'about', label: 'קצת עלי' },
    { id: 'portfolio', label: 'חתונות' },
    { id: 'services', label: 'מה אני מצלם' },
    { id: 'testimonials', label: 'מה זוגות מספרים' },
    { id: 'faq', label: 'שאלות נפוצות' },
    { id: 'contact', label: 'נדבר?' }
    ],
    websiteTitle: 'רמי פזהר - צלם',
    welcomeTitle: 'רמי פזהר',
    welcomeSubtitle: 'צלם',
    contactBtn: 'צור קשר',
    portfolioBtn: 'הצג תיק עבודות',
    introTitle: 'נעים להכיר, אני רמי, ואשמח לצלם את החתונה שלכם!',
    introSubtitle: 'אתם מתחתנים. אני מצלם. בלי בימוי מיותר ובלי לחץ — רק תמונות טבעיות מהיום שלכם.',
    introBody1: 'מעבר לצילום, אני מלווה אתכם במהלך כל היום, ולכן חשוב לי לתת לכם את ההרגשה הכי טובה וכייפית שאפשר, כמו חבר מלווה שמצטרף אליכם ביום המיוחד.',
    introVideoPlay: 'לחצו להפעלה',
    aboutTitle: 'מי אני',
    aboutGreeting: 'נעים להכיר!',
    aboutImageCaption: 'כן, אני בדרך כלל עם מצלמה ביד',
    aboutSubtitle: 'נעים מאוד, רמי פזהר, צלם. אוהב מאוד לצלם תמונות צבעוניות של אנשים יפים מאירועים מרגשים.',
    aboutParagraph1:   "אני רמי, צלם חתונות. אני אוהב אנשים, רגעים אמיתיים, ואת כל מה שקורה בין לבין - לא רק את הרגעים ה\"רשמיים\".",
    aboutParagraph2:   "הגעתי לצילום חתונות כי זה המקום שבו יש הכול: התרגשות, משפחה, חברים, והמון רגעים קטנים שקורים בלי תכנון מוקדם.",
    aboutParagraph3:   "ביום החתונה אני משתדל להיות בסביבה, אבל לא להרגיש. לא לנהל, לא להלחיץ, ולא לבקש מכם לעשות דברים שלא מרגישים לכם טבעיים.",
    aboutParagraph4:   "גם זוגות שאומרים לי מראש שהם לא אוהבים להצטלם מגלים די מהר שזה הרבה יותר פשוט ממה שהם חשבו. כשנוח - זה פשוט עובד.",
    aboutParagraph5:   "בסוף, המטרה שלי היא שתישארו עם תמונות שמרגישות כמו היום עצמו - כאלה שכיף לפתוח שוב, גם הרבה אחרי שהאירוע נגמר.",
    servicesTitle: 'מה אני מצלם',
    servicesSubtitle: 'אשמח להציע שירותי צילום מתחומים שונים, כולל צילומי אירועים, צילומי פורטרטים, צילומי נופים ועוד.',
    services: [
        { id: 'weddings', title: 'חתונות', description: 'צילום חתונות מקצועי, כולל צילומי זוגיות, טקסים ורגעים מיוחדים.', icon: <CameraIcon fontSize="large" />, image: weddingImage, link: 'https://studiorami.click' },
        { id: 'batMitzvah', title: 'בוק בת מצווה', description: 'צילום בוק בת מצווה מקצועי, כולל צילומים באווירה טבעית ומרגיעה.', icon: <EmojiEventsIcon fontSize="large" />, image: batMitzvaImage, link: 'https://studiorami.fun' },
        { id: 'events', title: 'אירועים', description: 'צילום אירועים פרטיים ועסקיים, כולל בר/בת מצווה, ימי הולדת ואירועי חברה.', icon: <CakeIcon fontSize="large" />, image: eventImage, link: 'https://studiorami.co.il' },
        { id: 'portraits', title: 'דוגמנות', description: 'צילום דוגמנות וצילומי פורטרטים מקצועיים' , icon: <Person fontSize="large" />, image: fashionImage, link: 'https://studiorami.click/models' },
        { id: 'maternity', title: 'צילומי הריון', description: 'צילום הריון מקצועי, כולל צילומים באווירה טבעית צילומי הריון בטבע, מזכרת נפלאה לזוגות המצפים.', icon: <PregnantWoman fontSize="large" />, image: maternityImage, link: 'https://studiorami.co.il/maternity' },
        { id: 'couples', title: 'צילומי זוגיות/ Save the Date', description: 'צילומי זוגיות בלוקיישנים מיוחדים ומרהיבים.', icon: <NaturePeople fontSize="large" />, image: coupleImage, link: 'https://studiorami.co.il/couples' }

    ],
    portfolioTitle: 'תמונות',
    portfolioSubtitle: 'כמה רגעים אמיתיים מיום החתונה',
    loadMoreBtn: 'תמונות נוספות',
    testimonialsTitle: 'כמה מילים מזוגות',
    testimonialsSubtitle: 'לא אני — הם מספרים!',
    testimonials: [
        {
            name: 'אנה',
            role: 'באר שבע',
            avatar: annaAvatar,
            text: `רמי האלוף!!!! רמי הוא צלם שרואה את הבני זוג, יודע לתפוס הרגע ולצלם את הרגש! 
רמי משקיע את כל כולו בכל צילום, בכל תמונה!  
רמי ליווה אותנו ממש מתחילת היום, והפך עבורנו את היום הזה לכייף ולא לחוץ כי הוא גם יודע ליצור אווירה נינוחה וקלילה.  
כל התמונות יצאו יפות ומרגשות. ממליצים בחום!`,
            rating: 5
        },
        {
            name: 'תמנה',
            role: 'נס ציונה',
            avatar: timnaAvatar,
            text: `חיפשתי צלם סטילס לחתונה שלנו שלא דופק מחיר מופקע כי מדובר בחתן וכלה. 
רמי פנה אליי בפייסבוק ומהר מאוד הבנתי שזה האדם שאני רוצה שיהיה הצלם בחתונה שלנו. 
כל כך סבלני, מבין, רגיש ולא דחף את עצמו עלינו. הכל הרגיש איתו כל כך טבעי! כמו דוד שבא לצלם את האחיינים שלו! 
הכי מקצועי, שליו ונעים. אין לי מילים; רק רוצה לומר לו אלף פעמים תודה!`,
            rating: 5
        },
        {
            id: 3,
            name: 'גל',
            role: 'תל אביב',
            avatar: galAvatar,
            rating: 5,
            text: `רמי היה הצלם בחתונה של אחותי!! איזה רגישות איזה מקצועיות. אחרי החתונה שלה היה לנו ברור שנסגור אותו גם והינה שנתיים אחר כך הוא הגיע לצלם אצלינו! תמיד מגיע ראשון מוקדם בבוקר ועוזב אחרון!!! בחיים לא ראיתי משהו שכל כך אכפת לו.איזה יחס לכלה ולאורחים תמיד בחיוך.רמי תודה רבה על הכל באמת אוהבים אותך מהלב!!`
        }
    ],
    testimonialsLinkText: 'להמלצות נוספות באתר mit4mit',
    testimonialsLinkUrl: 'https://www.mit4mit.co.il/biz/97817?',
    faqTitle: 'דברים ששואלים אותי',
    faqSubtitle1: 'אספתי כאן תשובות לשאלות שעולות כמעט תמיד.',
    faqSubtitle2: 'ואם נשאר משהו לא ברור — תמיד אפשר לשאול ואשמח לעזור.',
    faqItems: [
      {
        id: 1,
        question: 'מה כולל הצילום ביום החתונה?',
        answer:     'ליווי צילום לאורך יום החתונה - מההכנות, דרך הטקס ועד החלקים המרכזיים של האירוע. כל התמונות עוברות עריכה בסיסית ומסודרות בגלריה נוחה.'
      },
      {
        id: 2,
        question: 'אנחנו עם תקציב מוגבל, זה רלוונטי?',
        answer:     'כן. יש כמה אפשרויות וחבילות, וננסה למצוא פתרון שמתאים לכם ולסוג האירוע — בלי לחץ ובלי התחייבות.'
      },
      {
        id: 3,
        question: 'התמונות עוברות עריכה?',
        answer:
            'כן. כל התמונות עוברות עריכה של צבעים, תאורה ואווירה כללית. העריכה שומרת על מראה טבעי ולא כוללת ריטושים כבדים כמו שינויי גוף או עור.'
        },
    {    
        id: 4,
        question: 'תוך כמה זמן נקבל את התמונות?',
        answer:
            'בדרך כלל כשבוע עד שבועיים אחרי החתונה. אם יש אלבומים - תקבלו קישור לבחירת תמונות, ותהליך העיצוב וההדפסה לוקח בערך חודש מסיום בחירת התמונות.'
    },
    {
        id: 5,
        question: "האם יש שעת סיום לצילומים?",
        answer:     'ברוב החתונות הצילום מסתיים סביב 00:30. אם האירוע נמשך מעבר - אפשר להאריך את הצילום בתיאום מראש ובתוספת תשלום.'
    },
    {
        id: 6,
        question: "אנחנו לא יודעים להצטלם - מה עושים?",
        answer: 'רוב הזוגות לא רגילים להצטלם, וזה לגמרי בסדר. אני מנחה בעדינות כשצריך, אבל בעיקר נותן לדברים לקרות בצורה טבעית.'
    },
    {
        id: 7,
        question: "באיזה ציוד אתה משתמש?",
        answer:     'אני עובד עם ציוד Canon מקצועי ומביא איתי תמיד ציוד גיבוי מלא - כדי להיות מוכן לכל מצב.'

    },
    {
        id: 8,
        question: "האם יש לך ביטוח?",
        answer:     'כן. יש לי ביטוח צד ג\', כך שאתם יכולים להיות רגועים.'
    },
    {
        id: 9,
        question: "איך מתבצע התשלום?",
        answer: 'התשלום מתבצע בסוף האירוע או בקבלת החומרים - מה שנוח לכם. אפשר במזומן, צ\'ק, העברה בנקאית, ביט או פייבוקס.'

    },
    {
        id: 10,
        question: "האם יש דמי ביטול?",
        answer: 'לא. אני לא לוקח מקדמות ולא גובה דמי ביטול.'

    },
    {
        id: 11,
        question: 'אפשר פשוט לדבר לפני שמחליטים?',
        answer:
            'ברור. שיחת היכרות קצרה עוזרת להבין אם זה מתאים לשני הצדדים — בלי התחייבות.'
     }
    ],
    faqMoreQuestionsTitle: 'לא מצאתם תשובה?',
    faqMoreQuestionsBody: 'פשוט דברו איתי, אשמח לעזור!',
    contactTitle: 'נדבר?',
    contactSubtitle: 'אפשר להתקשר, לשלוח הודעה או מייל - מה שנוח לכם',
    contactSubtitle2: 'אני עונה בעצמי, לא בוט 🙂',
    contactInfoTitle: 'פרטי התקשרות',
    contactEmailTitle: 'דואר אלקטרוני',
    contactPhoneTitle: 'טלפון',
    contactWhatsappTitle: 'אפשר גם בוואטסאפ',
    contactFormName: 'איך קוראים לכם?',
    contactFormEmail: 'דואר אלקטרוני',
    contactFormPhone: "טלפון (לחזרה)",
    contactFormSubject: 'נושא',
    contactFormMessage: 'כמה מילים על החתונה',
    contactFormPlaceholderMessage: 'אפשר לכתוב חופשי 🙂',
    contactFormSendBtn: 'שלח הודעה',
    contactFormSending: 'שולח...',
    contactFormSuccess: 'ההודעה נשלחה 🙂 נדבר בקרוב',
    footerBrand: 'רמי פזהר - צלם',
    footerLinksTitle: 'קישורים',
    footerLinks: [
      { id: 'home', label: 'בית', href: '#home' },
      { id: 'about', label: 'קצת עלי', href: '#about' },
      { id: 'services', label: 'שירותים', href: '#services' },
      { id: 'portfolio', label: 'תמונות', href: '#portfolio' },
      { id: 'testimonials', label: 'המלצות', href: '#testimonials' },
      { id: 'faq', label: 'שאלות נפוצות', href: '#faq' },
      { id: 'contact', label: 'צור קשר', href: '#contact' }
    ],
    footerCopyright: 'רמי פזהר - צלם. כל הזכויות שמורות.',
    portfolioCategories: {
      engagement: 'צילומי זוגיות',
      preparations: 'התארגנות',      
      outdoor: 'צילומי חוץ',
      ceremony: 'טקס',
      party: 'מסיבה',
      
      // add more as needed
    }
  },
  en: {
    nav: [
      { id: 'home', label: 'Home' },
      { id: 'about', label: 'About' },
      { id: 'services', label: 'Services' },
      { id: 'portfolio', label: 'Portfolio' },
      { id: 'testimonials', label: 'Testimonials' },
      { id: 'faq', label: 'FAQ' },
      { id: 'contact', label: 'Contact' }
    ],
    websiteTitle: 'Rami Pazhar - Photographer',
    welcomeTitle: 'Rami Pazhar',
    welcomeSubtitle: 'Photographer',
    contactBtn: 'Contact',
    portfolioBtn: 'View Portfolio',
    introTitle: "Nice to meet you, I'm Rami, and I'd love to photograph your wedding!",
    introSubtitle: "For me, you're not just another wedding, you're another special couple I'd love to meet, join your special day, and capture your most beautiful moments.",
    introBody1: "Beyond photography, I accompany you throughout the day, so it's important for me to give you the best and most enjoyable feeling possible, like a friend joining you on your special day.",
    introVideoPlay: 'click to play',
    aboutTitle: 'About',
    aboutGreeting: 'Nice to meet you!',
    aboutImageCaption: 'Yes, I usually have a camera in my hand',
    aboutSubtitle: "I'm Rami Pazhar, photographer. I love taking colorful photos of beautiful people at exciting events.",
    aboutParagraph1: "I've loved photography since childhood. At age five, I got my first film camera. It was a kids' camera, but with real film, and I photographed all my family members. Over the years, I took many photos at every opportunity and enjoyed going to the photo shop every week to develop my pictures.",
    aboutParagraph2: "At age thirty, I bought my first DSLR camera, and since then I've taken hundreds of thousands of photos of people, family, friends, landscapes, and street photography.",
    aboutParagraph3: "In 2015, I started photographing events. Since then, I've photographed many events: small family birthdays, brits, company events, bar/bat mitzvahs, and weddings. Meeting people at happy events and participating in their joy excites me every time.",
    aboutParagraph4: "Happily married to Hamutal, father to Ido and Gal. All three are wonderful models and loyal business partners.",
    servicesTitle: 'Photography Services',
    servicesSubtitle: 'I offer photography services in various fields, including event photography, portraits, landscapes, and more.',
    services: [
        { id: 'weddings', title: 'Weddings', description: 'Professional wedding photography, including couple shoots, ceremonies, and special moments.', icon: <CameraIcon fontSize="large" />, image: weddingImage, link: 'https://studiorami.click'},
        { id: 'batMitzvah', title: 'Bat Mitzvah', description: 'Professional Bat Mitzvah photo shoot, including natural and relaxing atmosphere.', icon: <EmojiEventsIcon fontSize="large" />, image: batMitzvaImage, link: 'https://studiorami.fun'},
        { id: 'events', title: 'Events', description: 'Photography for private and corporate events, including bar/bat mitzvahs, birthdays, and company events.', icon: <CakeIcon fontSize="large" />, image: eventImage, link: 'https://studiorami.co.il'},
        { id: 'portraits', title: 'Fashion/Modeling', description: 'Fashion photography and professional portrait shoots.', icon: <Person fontSize="large" />, image: fashionImage, link: 'https://studiorami.click/models'},
        { id: 'maternity', title: 'Maternity', description: 'Professional maternity photography, including natural outdoor shoots, a wonderful keepsake for expecting couples.', icon: <PregnantWoman fontSize="large" />, image: maternityImage, link: 'https://studiorami.co.il/maternity'},
        { id: 'couples', title: 'Couple Shoots / Save the Date', description: 'Couple photography in special and stunning locations.', icon: <NaturePeople fontSize="large" />, image: coupleImage, link: 'https://studiorami.co.il/couples'}
    ],
    portfolioTitle: 'Photos',
    portfolioSubtitle: '',
    loadMoreBtn: 'More Photos',
    testimonialsTitle: 'Testimonials',
    testimonialsSubtitle: 'Read what other couples have to say!',
    testimonials: [
        {
            name: 'Anna Kolosov',
            role: 'Beer Sheva',
            avatar: annaAvatar,
            rating: 5,
            text: `Rami is a genius!!!! Rami is a photographer who sees the couple, knows how to capture the moment and photograph the emotion!`
        },
        {
            name: 'Timna Meduel',
            role: 'Nes Ziona',
            avatar: timnaAvatar,
            rating: 5,
            text: `I was looking for a still photographer for our wedding who doesn't charge an exorbitant price because it's a groom and bride. Rami contacted me on Facebook, and I quickly realized that this is the person I want to be the photographer at our wedding. So patient, understanding, sensitive, and not pushy. Everything felt so natural with him! Like an uncle who comes to photograph his nieces! The most professional, calm, and pleasant. I have no words; I just want to say thank you a thousand times!`
        },
        {
            id: 3,
            name: 'Gal Harmoni',
            role: 'Tel Aviv',
            avatar: galAvatar,
            rating: 5,
            text: `Rami was the photographer at my sister's wedding!! What sensitivity, what professionalism. After her wedding, we were sure we would book him too, and here we are two years later, he came to photograph us! Always arrives first early in the morning and leaves last!!! I've never seen someone who cares so much. What a attitude towards the bride and guests, always with a smile. Rami, thank you so much for everything, really love you from the heart!!`
        }
        
    ],
    testimonialsLinkText: 'More reviews on mit4mit',
    testimonialsLinkUrl: 'https://www.mit4mit.co.il/biz/97817?',
    faqTitle: 'FAQ',
    faqSubtitle: 'Here you can find answers to frequently asked questions.<br/>If you have another question, feel free to contact me.',
    faqItems: [
    {
        id: 1,
        question: 'What does your service include?',
        answer: 'Our service includes professional event photography, photo editing, and digital album production.'
    },
    {
        id: 2,
        question: 'Do you work with a limited budget?',
        answer: 'Yes, we offer different packages that can fit any budget.'
    },
    {
        id: 3,
        question: 'Are the photos edited?',
        answer: 'Yes. All photos are edited for color and brightness correction. The price does not include advanced retouching such as skin blemish removal or slimming.'
    },
    {
        id: 4,
        question: 'How soon will we receive the photos?',
        answer: 'About one to two weeks after the event, you will receive a USB drive with the edited photos. If you chose a package with albums, you will get a link to select photos for the album. Album design and printing takes about a month after photo selection. The video delivery depends on the videographer and is coordinated with them.'
    },
    {
        id: 5,
        question: 'Is there a finish time for the photography?',
        answer: 'An average wedding ends around 0:30, so that is the finish time for photography. If the wedding continues late, it is possible to extend photography hours for an additional fee.'
    },
    {
        id: 6,
        question: "What if we don't know how to pose?",
        answer: "Don't worry! Most couples are not models and are not used to posing. During the day, I will adapt to you, help with direction if needed, and give you space for authentic photos."
    },
    {
        id: 7,
        question: 'What equipment do you use?',
        answer: 'I use professional Canon cameras, including several camera bodies and prime and zoom lenses. I always bring backup equipment to every shoot to ensure I am prepared for any situation or technical issue.'
    },
    {
        id: 8,
        question: 'Do you have insurance?',
        answer: "Yes, of course, I am always insured with third-party insurance, just in case."
    },
    {
        id: 9,
        question: 'What are the payment terms?',
        answer: "You can pay for my services at the end of the event or when receiving the materials, whichever is convenient for you. Payment can be made in cash, check, bank transfer, Bit, or PayBox. <b>Payment to third-party photographers is made at the end of the event.</b>"
    },
    {
        id: 10,
        question: 'Are there cancellation fees?',
        answer: "Since I started working as a photographer, I have never taken deposits or cancellation fees."
    }
    ],
    faqMoreQuestionsTitle: 'More questions?',
    faqMoreQuestionsBody: "Feel free to contact me and I'll be happy to help!",
    contactTitle: 'Contact',
    contactSubtitle: 'Have a question? Want to schedule a meeting? I am here to help!',
    contactInfoTitle: 'Contact Information',
    contactEmailTitle: 'Email',
    contactPhoneTitle: 'Phone',
    contactFormName: 'Name',
    contactFormEmail: 'Email',
    contactFormPhone: 'Phone Number',
    contactFormSubject: 'Subject',
    contactFormMessage: 'Message',
    contactFormSendBtn: 'Send Message',
    contactFormSending: 'Sending...',
    contactFormSuccess: 'Message sent successfully! I will contact you soon.',
    footerBrand: 'Rami Pazhar - Photographer',
    footerLinksTitle: 'Links',
    footerLinks: [
      { id: 'home', label: 'Home', href: '#home' },
      { id: 'about', label: 'About', href: '#about' },
      { id: 'services', label: 'Services', href: '#services' },
      { id: 'portfolio', label: 'Photos', href: '#portfolio' },
      { id: 'testimonials', label: 'Testimonials', href: '#testimonials' },
      { id: 'faq', label: 'FAQ', href: '#faq' },
      { id: 'contact', label: 'Contact', href: '#contact' }
    ],
    footerCopyright: 'Rami Pazhar - Photographer. All rights reserved.',
    portfolioCategories: {
      engagement: 'Engagement',
      preparations: 'Preparations',
      outdoor: 'Outdoor',
      ceremony: 'Ceremony',      
      party: 'Party',
      
      // add more as needed
    }
  }
};

export default translations;
